import styled from 'styled-components';
import Box from '@mui/material/Box';

export const stepperContainerClass = 'fleets-onboarding-stepper-container';
export const contentClass = 'fleets-onboarding-content';

export const OnboardingRoot = styled(Box)`
  .${stepperContainerClass} {
    margin: 0 auto;
    max-width: 900px;
  }

  .${contentClass} {
    margin: 0 auto;
    max-width: 700px;
  }
`;
